export default __webpack_public_path__ + "static/media/Calendar.80a1bc5d.svg";